import './switch.scss';
import React, { useEffect, useState, memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Label, useTheme } from '..';
const Switch = _ref => {
  let {
    checked,
    className,
    dataName,
    disabled,
    label,
    name,
    onChange,
    onClick,
    title,
    value
  } = _ref;
  const {
    theme
  } = useTheme();
  const [internalChecked, setInternalChecked] = useState(checked);
  useEffect(() => {
    setInternalChecked(checked);
  }, [checked]);
  const handleOnChange = e => {
    if (!disabled && onChange) {
      const switchChecked = e.target.checked;
      setInternalChecked(switchChecked);
      onChange(switchChecked, value);
    }
  };
  const handleOnClick = () => {
    if (onClick) onClick();
  };
  return /*#__PURE__*/React.createElement("label", {
    className: classNames('wrts-switch', className, theme, {
      disabled
    }),
    onClick: handleOnClick,
    "data-name": dataName
  }, title && /*#__PURE__*/React.createElement("span", {
    className: "wrts-switch-title"
  }, title), label && /*#__PURE__*/React.createElement(Label, {
    title: label
  }), /*#__PURE__*/React.createElement("div", {
    className: "wrts-switch-input"
  }, /*#__PURE__*/React.createElement("input", {
    checked: internalChecked,
    name: name,
    onChange: handleOnChange,
    type: "checkbox",
    value: value,
    disabled: disabled
  }), /*#__PURE__*/React.createElement("span", {
    className: "backdrop"
  }), /*#__PURE__*/React.createElement("span", {
    className: "visual"
  })));
};
Switch.defaultProps = {
  checked: false,
  disabled: false,
  name: 'switch',
  value: 'switch',
  dataName: ''
};
Switch.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  dataName: PropTypes.string,
  className: PropTypes.string
};
export default /*#__PURE__*/memo(Switch);